module.exports = __webpack_public_path__ + "4e6ed536c4a23f54848a289cd22eb81d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/googley-21.png
// module id = 1499
// module chunks = 0